import React, { useState, useEffect } from "react";
import { Link,useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  Breadcrumb,
  Button,
  Card,
  Container,
  Row,
  Col,
  Modal,
  Form,
} from "react-bootstrap";

import {
  CustomPaging,
  EditingState,
  PagingState,
  SortingState,
  SearchState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableEditColumn,
  SearchPanel,
  TableColumnResizing,
  Toolbar,
} from '@devexpress/dx-react-grid-bootstrap4';

import { Loading } from 'components/Loading/loading';
import PopupEditing from 'components/ReactTable/PopupEditing.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import Popup from './Popup.js';

const SORT_FIELD_MAP = {
  standard: 'standard.STANDARD_NAME',
  score: 'score.SCORE_NAME',
};

export default function Index() {

  const history = useHistory();
  const [swal, setSwal] = useAlert();
  const [columns] = useState([
    { name: 'INSTRUMENT_ID', title: 'ID' },
    { name: 'standard', title: 'Standard', getCellValue: row => (row.standard) ? row.standard.STANDARD_NAME : `n-a` },
    { name: 'INSTRUMENT_NAME', title: 'Name'},
    { name: 'score', title: 'Score', getCellValue: row => (row.score) ? row.score.SCORE_NAME : `n-a`},
    { name: 'INSTRUMENT_STATUS', title: 'Status' },
    { name: 'action', title: 'Action' },
  ]);

  const ActionCell = ({ row, column, ...restProps }) =>
  column.name === "action" ? (
    <Table.Cell>
      <Button
        onClick={() => {
          handlePopup(row)
        }}
      >
        Duplicate
      </Button>
    </Table.Cell>
  ) : (
    <Table.Cell row={row} column={column} {...restProps} />
  );

  const [defaultColumnWidths] = useState([
    { columnName: 'INSTRUMENT_ID', width: 70 },
    { columnName: 'standard', width: 200 },
    { columnName: 'INSTRUMENT_NAME', width: 300 },
    {columnName: 'score', width: 150 },
    {columnName: 'INSTRUMENT_STATUS', width: 120 },
    {columnName: 'action', width: 120 },
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);

  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState([{ columnName: 'INSTRUMENT_ID', direction: 'asc' }]);
  const [searchValue, setSearchValue] = useState('');
  const [idInst, setIdInst] = useState('');
  const [standardName, setStandardName] = useState('');
  const [instName, setInstName] = useState('');
  const [popDupl, setPopDupl] = useState(false);
  const [spreadsheetName, setSpreadsheetName] = useState(``);
  const [documentName, setDocumentName] = useState(``);
  const [rowDuplicate, setRowDuplicate] = useState({});
  const [formF, setFormF] = useState({});
  const [reportF, setReportF] = useState({});
  const [standards, setStandards] = useState([]);
  const [scores, setScores] = useState([]);
  const [std, setStd] = useState('');
  const [scrs, setScrs] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const commitChanges = async ({ added, deleted }) => {

    try {

      let payload = new FormData();

      if (added) {

        const newItem = {...added.pop()};
        Object.keys(newItem).forEach(function(key) {
          payload.append(key, newItem[key]);
        });

        payload.append('INSTRUMENT_STATUS', 'DRAFT');

        const response = await axios.post(
          `${process.env.REACT_APP_API_HOST}instruments`,
          payload,
          {
            params: {expand: `standard,score`},
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
              "Content-Type": `multipart/form-data; charset=utf-8; boundary="${Math.random().toString().substr(2)});`,
            },
          }
        );

        setRows([
          ...rows,
          {
            ...response.data,
            INSTRUMENT_STATUS: 'DRAFT',
          }
        ]);

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Create Success`,
            message: `New user successfully created.`,
          }
        });

      }

      if (deleted) {
        const item = rows.find(row => row.INSTRUMENT_ID === [...deleted].pop());
        const onSuccessCallback = async () => {
          const response = await axios.delete(`${process.env.REACT_APP_API_HOST}instruments/${item.INSTRUMENT_ID}`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
            },
          });
          setRows([...rows].filter(row => row.INSTRUMENT_ID !== item.INSTRUMENT_ID))
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Are you sure?`,
            message: `You are about to delete "${item.standard.STANDARD_NAME} ${item.INSTRUMENT_NAME}" instrument.`,
            onSuccess: {
              title: `Success`,
              message: `Delete Success`,
              callback: onSuccessCallback,
            }
          }
        });
      }

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
     }
  };

  const getRowId = row => row.INSTRUMENT_ID;

  const fetchData = async () => {

    setLoading(true);

    try {

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}instruments`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
        params: {
          expand: `standard,score`,
          page: currentPage + 1,
          'per-page': pageSize,
          'search': searchValue,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }

    setLoading(false);
  }

  const handleClose = () => {
    setPopDupl(false);
  };

  const onChangeForm = (e) => {
    const formF = {
      name: 'form',
      value: e.target.files[0]
    };
    setSpreadsheetName(e.target.files[0].name)
    setFormF(formF);
  };

  const onChangeReport= (e) => {
    const reportF = {
      name: 'report',
      value: e.target.files[0]
    };
    setDocumentName(e.target.files[0].name)
    setReportF(reportF);
  };

  const handleChangeName = (event) => {
    setInstName(event.target.value);
  };

  const handleChangeStd = (event) => {
    setStd(event.target.value);
  };

  const handleChangeScore = (event) => {
    setScrs(event.target.value);
  };

  function handlePopup(row){
    setRowDuplicate(row);
    setIdInst(row.INSTRUMENT_ID)
    setInstName(row.INSTRUMENT_NAME);
    setPopDupl(true);
  }

  const commitDuplicate = async () => {
    setPopDupl(false);
    setIsLoading(true);
    try {

      let payload = new FormData();

      // Object.keys(rowDuplicate).forEach(function(key) {
      //   if(key=='INSTRUMENT_NAME' || key=='STANDARD_ID' || key=='SCORE_ID'){
      //     payload.append(key, rowDuplicate[key]);
      //   };
      // });
      payload.append('INSTRUMENT_NAME',instName);
      payload.append('STANDARD_ID',std);
      payload.append('SCORE_ID',scrs);
      payload.append(formF['name'],formF['value']);
      payload.append(reportF['name'],reportF['value']);
      payload.append('INSTRUMENT_STATUS', 'DRAFT');
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}instruments`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
            "Content-Type": `multipart/form-data; charset=utf-8; boundary="${Math.random().toString().substr(2)});`,
          },
        }
      );

      const responseDuplicate = await axios.get(`${process.env.REACT_APP_API_HOST}instrument/duplicate?id=${idInst}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
        params: {}
      });
      setIsLoading(false);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
     }
    setIsLoading(false);
  }

  const handleTest = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false)
      console.log("Time : ");
    }, 6000);
  }

  function handleDuplicate(){
    setPopDupl(false);

    const duplicate = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}instrument/duplicate?id=${id}`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          },
          params: {}
        });
      } catch (error) {
        setSwal({
          type: TYPES.ERROR,
          payload: {
            message: error.toString(),
          }
        });
      }
    }

    setSwal({
      type: TYPES.CONFIRM,
      payload: {
        title: `Are you sure?`,
        message:`You are about to duplicate "${sName} ${iName}" instrument.`,
        onSuccess: {
          title: `Success`,
          message: `Duplicate Success`,
          callback: duplicate,
        }
      }
    });

  }

  const fetchStandard = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}standards`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
        params: {
          all: true,
        }
      });

      setStandards(response.data.items);

    } catch (error) {
      alert(error)
    }
  }

  const fetchScore = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}scores`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
        params: {
          all: true,
        }
      });

      setScores(response.data.items);

    } catch (error) {
      alert(error)
    }
  }

  useEffect(() => {

    fetchStandard();
    fetchScore();

    return () => {}
  }, [])

  useEffect(fetchData, [searchValue, pageSize, currentPage, sorting]);

  useEffect(() => {

    if (editingRowIds && editingRowIds.length > 0) {
      return history.push(`/admin/instruments/${editingRowIds.pop()}/edit`);
    }

  }, [editingRowIds]);

  return (
    <>
      {swal}
      <Container fluid>
        <Modal
          show={isLoading}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Loading />
        </Modal>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Instrument
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Index
          </Breadcrumb.Item>
        </Breadcrumb>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">List of Instrument's Template</Card.Title>
              </Card.Header>
              <Card.Body>
                <Grid
                  rows={rows}
                  columns={columns}
                  getRowId={getRowId}
                >
                  <SearchState onValueChange={setSearchValue} />

                  <PagingState
                    currentPage={currentPage}
                    onCurrentPageChange={setCurrentPage}
                    pageSize={pageSize}
                    onPageSizeChange={setPageSize}
                  />
                  <SortingState
                      sorting={sorting}
                      onSortingChange={setSorting}
                    />
                  <CustomPaging totalCount={totalCount} />
                  <EditingState
                    editingRowIds={editingRowIds}
                    onEditingRowIdsChange={setEditingRowIds}
                    onCommitChanges={commitChanges}
                  />
                  <Table cellComponent={ActionCell}/>
                  <TableColumnResizing
                    columnWidths={columnWidths}
                    onColumnWidthsChange={setColumnWidths}
                  />
                  <TableHeaderRow showSortingControls />
                  <TableEditColumn
                    showAddCommand
                    showEditCommand
                    showDeleteCommand
                  />
                  <PagingPanel
                    pageSizes={pageSizes}
                  />
                  <PopupEditing popupComponent={Popup} />
                  <Toolbar />
                  <SearchPanel />
                  {loading && <Loading />}
                </Grid>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Modal show={popDupl} onHide={handleClose} backdrop="static" keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>Duplicate Instrument Form</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Standard <span className="text-danger">*</span></Form.Label>
              <Form.Control defaultValue={-1} name="STANDARD_ID" as="select" onChange={handleChangeStd}>
                <option value={-1}>Please Select...</option>
                {standards && standards.map((standard, key) => (
                  <option key={key} value={standard.STANDARD_ID}>
                    {standard.STANDARD_NAME}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Name <span className="text-danger">*</span></Form.Label>
              <Form.Control name="INSTRUMENT_NAME" onChange={handleChangeName} value={instName}/>
            </Form.Group>
            <Form.Group>
              <Form.Label>Score Index:  <span className="text-danger">*</span></Form.Label>
              <Form.Control name="SCORE_ID" as="select" onChange={handleChangeScore}>
                <option value={-1}>Please Select...</option>
                {scores && scores.map((score, key) => (
                  <option key={key} value={score.SCORE_ID}>
                    {score.SCORE_NAME}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
                <Form.Label>Form Spreadsheet Template  <span className="text-secondary">(Optional)</span></Form.Label>
                <Form.File
                  id="form-file"
                  label="Choose File"
                  custom
                  name='form'
                  label={spreadsheetName}
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                  onChange={onChangeForm}
                />
              </Form.Group>
            <Form.Group>
                <Form.Label>Report Document Template  <span className="text-danger">*</span></Form.Label>
                <Form.File
                  id="report-file"
                  label="Choose File"
                  custom
                  name='report'
                  label={documentName}
                  accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  onChange={onChangeReport}
                />
              </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={commitDuplicate}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
}